import React from "react";
import Highlighter from "react-highlight-words";
import { removeAllTags, thousandsSeparators } from "../../../../config/utils";
import moment from "moment";
import { DYNAMIC_FIELD_TYPES } from "../../constants";
import { getOptionColor, readableTextColor } from "../../../../utils/optionColors";
import "./dynamicField.css";

export const DynamicField = ({ rowData, config, keyItem, numberSearchArray, filterHighlighter, caseSensitive = false }) => {
    const fieldObject = rowData?.dynamic_fields;
    const type = config[keyItem]?.type;
    const { thousand_separator = false, prefix = "", suffix = "" } = config[keyItem]?.rules || {};

    const rawValue = fieldObject?.[keyItem]?.value;
    let data = rawValue == null ? "" : rawValue;
    if (data !== "" && type === DYNAMIC_FIELD_TYPES.DATE) {
        data = moment(data).format("MM-DD-YYYY");
    }
    // Numbers only: thousandsSeparators returns "" for anything else, which would blank a text column's rows.
    if ((thousand_separator || type === DYNAMIC_FIELD_TYPES.CURRENCY) && data !== "" && !isNaN(data)) {
        data = thousandsSeparators(data);
    }
    if ((prefix || suffix) && data !== "") {
        data = `${prefix}${data}${suffix}`;
    }
    if (type === DYNAMIC_FIELD_TYPES.BOOLEAN) {
         data = fieldObject?.[keyItem]?.value;
        data =
            data === true || data === "true" || data === "Yes" || data === "yes"
                ? "Yes"
                : data === false || data === "false" || data === "No" || data === "no"
                  ? "No"
                  : "-";
    }
    const optionColor = getOptionColor(config[keyItem]?.optionColors, fieldObject?.[keyItem]?.value);

    const content = (
        <>
            {data !== "" ? (
                <Highlighter
                    className="text-highlighter"
                    unhighlightClassName="text-unhighlight"
                    searchWords={filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                    textToHighlight={type === DYNAMIC_FIELD_TYPES.MEMO ? (removeAllTags(data ?? "") ?? "-") : (data?.toString() ?? "-")}
                    data-tip={data}
                    data-effect="solid"
                    data-place="bottom"
                    data-for={`table`}
                    data-class="rc-tooltip-custom-class"
                    caseSensitive={caseSensitive ?? false}
                />
            ) : (
                "-"
            )}
        </>
    );

    if (!optionColor || !data) return content;

    return (
        <span
            className="dynamic-field-color-pill"
            style={{ background: optionColor, color: readableTextColor(optionColor) }}
            data-tip={data}
            data-effect="solid"
            data-place="bottom"
            data-for={`table`}
            data-class="rc-tooltip-custom-class"
        >
            {content}
        </span>
    );
};
